import React from 'react';
import ContentLoader from 'react-content-loader';

const CardHeaderSkeleton = () => {
  return (
    <div className="p-[16px] sm:px-[24px] bg-neutral-10 border-b border-neutral-40">
      <ContentLoader
        width="100%"
        height={77}
        backgroundColor="var(--neutral-200)"
        foregroundColor="var(--neutral-400)"
      >
        <rect
          x="0"
          y="0"
          rx="0"
          ry="0"
          width="100%"
          height="100%"
          className="m-[16px]"
        />
      </ContentLoader>
    </div>
  );
};

export default CardHeaderSkeleton;
